import type { IColor } from '@color';
import { immerable } from '@utils';

export interface RectBorders {
  left: number;
  right: number;
  top: number;
  bottom: number;
}

export interface BetweenChildBorders {
  betweenChildren: number;
}

export type BorderWidth = RectBorders | BetweenChildBorders;

export class BorderElementConfig {
  [immerable] = true;

  color?: IColor;
  width: BorderWidth = { left: 0, right: 0, top: 0, bottom: 0 };
}
